import api from '@/shared/api/api-client';

import { enrichmentStatsSchema, type StatsRange } from '../domain/stats.domain';
import type { EnrichmentStatsGateway } from './enrichment-stats.gateway';

const STATS_ENDPOINT = '/enrichment-sessions/stats';

/** `?from=…&to=…` for a range, nothing at all without one. */
function statsPath(range?: StatsRange): string {
  if (!range) return STATS_ENDPOINT;
  const params = new URLSearchParams({ from: range.from, to: range.to });
  return `${STATS_ENDPOINT}?${params.toString()}`;
}

/**
 * Real stats read over the shared api client. The single place that knows the
 * stats endpoint; both feature gateways spread it in. Validates the payload at
 * the boundary with Zod.
 */
export const enrichmentStatsHttp: EnrichmentStatsGateway = {
  fetchStats: async (range) => enrichmentStatsSchema.parse(await api.get<unknown>(statsPath(range))),
};
